import { defineStore, acceptHMRUpdate } from 'pinia'
import { supabase, supabaseDomain } from '@/plugins/supabase'

// eslint-disable-next-line import/prefer-default-export
export const useWorkspacesMigrationsStore = defineStore({
  id: 'workspaces_migrations',
  state: () => ({
    migration: null,
  }),
  getters: {

  },
  actions: {
    async getMigrations(payload) {
      const from = payload?.options ? (payload.options.page - 1) * payload.options.itemsPerPage : 0
      const to = payload?.options ? from + payload.options.itemsPerPage - 1 : 0

      let query = supabase
        .from('workspaces_migrations')
        .select(
          '*',
          { count: 'exact' },
        )
        .eq('workspace_id', payload.workspaceId)

      if (payload?.options?.sortBy && payload?.options?.sortDesc) {
        let i = 0
        payload.options.sortBy.forEach(item => {
          query = query.order(item, { ascending: payload.options.sortDesc[i] })
          i += 1
        })
      }

      if (payload?.search) {
        query = query.or(`name.ilike.%${payload.search}%`)
      }
      if (payload?.options?.itemsPerPage !== -1 && from !== to) query = query.range(from, to)
      const { data, count, error } = await query
      if (error) {
        throw error
      }

      return { data, count }
    },

    async getMigration(id) {
      const { data, error } = await supabase
        .from('workspaces_migrations')
        .select(
          '*',
        )
        .eq('id', id)
        .single()
      if (error) {
        throw error
      }
      data.secret = data.decrypted_secret

      return data
    },

    async listenMigrations(workspaceId) {
      if (supabaseDomain.indexOf('localhost') < 0) {
        return supabase
          .channel('listenMigrations')
          .on('postgres_changes', {
            event: '*', schema: 'public', table: 'workspaces_migrations', filter: `workspace_id=eq.${workspaceId}`,
          }, async payload => {
            this.$patch({ eventType: payload.eventType, item: payload.new.id ? payload.new : payload.old })
          })
          .subscribe()
      }

      return null
    },

    async listenMigration(id) {
      this.migration = await this.getMigration(id)

      return supabase
        .channel(`listenMigration-${id}`)
        .on(
          'postgres_changes',
          {
            event: '*',
            schema: 'public',
            table: 'workspaces_migrations',
            filter: `id=eq.${id}`,
          },
          async () => {
            this.migration = await this.getMigration(id)
          },
        )
        .subscribe()
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useWorkspacesMigrationsStore, import.meta.hot))
}
